import { z } from "zod";

export interface IEditFormProps {
  disableEditMode: () => void;
  currentAvatar: string | null;
  structureId: string;
  structureName: string;
}

export interface IFormValues {
  name: string;
  avatarBase64: string | null;
  deleteAvatar: boolean;
}

export const EditStructureFormSchema = z.object({
  name: z
    .string()
    .trim()
    .min(3, "Nazwa jest za krótka. Minimum 3 znaki")
    .max(128, "Nazwa jest za długa. Maksymalnie 128 znaków"),
  avatarBase64: z.string().nullable().optional(),
  deleteAvatar: z.boolean(),
});
